import { useRecordContext, useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { Badge } from "@/components/ui/badge";

import type { Sale } from "../types";
import { TopToolbar } from "../layout/TopToolbar";
import { getUserRole } from "./userRoles";

const SalesListActions = () => (
  <TopToolbar>
    <ExportButton />
    <CreateButton label="resources.sales.action.new" />
  </TopToolbar>
);

const filters = [<SearchInput source="q" alwaysOn />];

const OptionsField = (_props: { label?: string | boolean }) => {
  const record = useRecordContext();
  const translate = useTranslate();
  if (!record) return null;

  const role = getUserRole(
    record as unknown as Pick<Sale, "administrator" | "manager">,
  );
  const roleLabel =
    role === "admin"
      ? translate("resources.sales.roles.admin", { _: "Administrator" })
      : role === "manager"
        ? translate("resources.sales.roles.manager", { _: "Manager" })
        : translate("resources.sales.roles.user", { _: "User" });

  return (
    <div className="flex flex-row gap-1">
      <Badge
        variant="outline"
        className={
          role === "admin"
            ? "border-blue-300 dark:border-blue-700"
            : role === "manager"
              ? "border-violet-300 dark:border-violet-700"
              : ""
        }
      >
        {roleLabel}
      </Badge>
      {record.disabled && (
        <Badge
          variant="outline"
          className="border-orange-300 dark:border-orange-700"
        >
          {translate("resources.sales.fields.disabled")}
        </Badge>
      )}
    </div>
  );
};

export function SalesList() {
  return (
    <List
      filters={filters}
      actions={<SalesListActions />}
      sort={{ field: "first_name", order: "ASC" }}
    >
      <DataTable>
        <DataTable.Col source="first_name" />
        <DataTable.Col source="last_name" />
        <DataTable.Col source="email" />
        <DataTable.Col source="role" label="resources.sales.fields.role">
          <OptionsField />
        </DataTable.Col>
      </DataTable>
    </List>
  );
}
